<div class="form-group mb-3" [formGroup]="parentForm">
  <div class="textarea">
    <textarea
      class="form-control"
      [placeholder]="placeholder"
      [formControlName]="formControlProp ?? null"
      [rows]="rows"
    ></textarea>
  </div>
</div>
